
package com.example.mystybag.sharedmodels.project.logic.enums

enum class ReservationStatus {
    CANCELED,               // Резервирано (-1)
    RESERVED,               // Резервирано (0)
    PAID,                   // Платено (1)49876500
    DELIVERED_TO_CLIENT,    // Получено от клиента (2)
    PAID_TO_MERCHANT;       // Изплатено на търговеца (3)

    val code: Int
        get() = when (this) {
            CANCELED -> -1
            RESERVED -> 0
            PAID -> 1
            DELIVERED_TO_CLIENT -> 2
            PAID_TO_MERCHANT -> 3
        }

    companion object {
        fun fromInt(value: Int): ReservationStatus {
            return when (value) {
                -1 -> CANCELED
                0 -> RESERVED
                1 -> PAID
                // Legacy backend status "ready for pickup" is treated as delivered in the new flow.
                2 -> DELIVERED_TO_CLIENT
                3 -> PAID_TO_MERCHANT
                else -> RESERVED // Default fallback
            }
        }
    }
}